import { BsCheckCircleFill, BsCircleFill } from "react-icons/bs";
import { GoShieldCheck } from "react-icons/go";
import { LuClock, LuMonitor } from "react-icons/lu";
import { Card, CardBody, Col, Row, TabPane } from "reactstrap";
import { useTranslation } from "react-i18next";

function OverviewTab({settings, loginLogs, activeDevices}) {
  const { t } = useTranslation();

  const active2FA = Number(settings?.security?.['auth.enabled_2fa']) === 1;
  const lastLogin = loginLogs?.[0]?.created_at ? new Date(loginLogs[0].created_at).toLocaleString() : 'N/A';
  const activeDevicesCount = activeDevices?.length || 0;
  const loginAlertsActive = Number(settings?.security?.['login.alert_on_failed_attempts']) === 1;
  const newDeviceDetection = Number(settings?.security?.['login.new_device_detection']) === 1;

  return(
    <TabPane tabId="overview">
      <Row className="g-3 mb-4">
        <Col lg="4" sm="6">
          {active2FA ?
            <Card>
              <CardBody className="d-flex align-items-center gap-3">
                <div className="stat-icon bg-success bg-opacity-10">
                  <GoShieldCheck size={20} className="text-white" />
                </div>
                <div>
                  <p className="text-muted small mb-0">{t('security.twoFAStatus')}</p>
                  <p className="fw-bold mb-0">{t('common.enabled')}</p>
                </div>
              </CardBody>
            </Card>
          :
            <Card>
              <CardBody className="d-flex align-items-center gap-3">
                <div className="stat-icon bg-danger bg-opacity-10">
                  <GoShieldCheck size={20} className="text-white" />
                </div>
                <div>
                  <p className="text-muted small mb-0">{t('security.twoFAStatus')}</p>
                  <p className="fw-bold mb-0">{t('common.disabled')}</p>
                </div>
              </CardBody>
            </Card>
          }
        </Col>
        <Col lg="4" sm="6">
          <Card>
            <CardBody className="d-flex align-items-center gap-3">
              <div className="stat-icon bg-primary bg-opacity-10">
                <LuClock size={20} className="text-white" />
              </div>
              <div>
                <p className="text-muted small mb-0">{t('security.lastLogin')}</p>
                <p className="fw-bold mb-0">{lastLogin}</p>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col lg="4" sm="6">
          <Card>
            <CardBody className="d-flex align-items-center gap-3">
              <div className="stat-icon bg-info bg-opacity-10">
                <LuMonitor size={20} className="text-white" />
              </div>
              <div>
                <p className="text-muted small mb-0">{t('security.activeSessions')}</p>
                <p className="fw-bold mb-0">{t('security.devicesCount', { count: activeDevicesCount })}</p>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Card>
        <CardBody>
          <p className="text-muted small fw-semibold text-uppercase mb-3">{t('security.securityChecklist')}</p>
          {[
            { isActive: active2FA, label:  active2FA ? t('security.twoFAEnabled') : t('security.twoFADisabled')         },
            { isActive: loginAlertsActive, label:  loginAlertsActive ? t('security.loginAlertsActive') : t('security.loginAlertsInactive')            },
            { isActive: true, label: `${activeDevicesCount} ${t('security.activeSessions')}`        },
            { isActive: true, label: t('security.strongPasswordPolicy')         },
            { isActive: newDeviceDetection, label: newDeviceDetection ? t('security.newDeviceDetectionOn') : t('security.newDeviceDetectionOff')         },
          ].map((item, i) => (
            <div key={i} className="d-flex align-items-center gap-2 mb-2">
              {item.isActive ?
                <BsCheckCircleFill size={15} className="text-success flex-shrink-0" />
              :
                <BsCircleFill size={15} className="text-danger flex-shrink-0" />
              }
              <span>{item.label}</span>
            </div>
          ))}
        </CardBody>
      </Card>
    </TabPane>
  );
}

export default OverviewTab;
